import { type UserEntity } from "@/api/__generated__/orval/auth";

export type WorkspaceToDisplay = {
  workspaceId: string;
  accountId: string;
};

/**
 * Get the workspaces to display for the current user.
 * @param currentUser - The current user.
 * @returns An array of workspaces to display.
 */
export const getWorkspacesToDisplay = (
  currentUser: UserEntity
): WorkspaceToDisplay[] => {
  const result: WorkspaceToDisplay[] = [];

  Object.entries(currentUser.permissions || {}).forEach(
    ([accountId, accountPermissions]) => {
      Object.entries(accountPermissions?.organizations || {}).forEach(
        ([, orgPermissions]) => {
          Object.keys(orgPermissions?.workspaces || {}).forEach(
            (workspaceId) => {
              result.push({ workspaceId, accountId });
            }
          );
        }
      );
    }
  );

  return result;
};
